<template>
  <div class="auth">
    <div class="auth-banner">
      <img
        class="auth-banner-image"
        src="../assets/images/auth-doctor-banner.jpeg"
        alt="Doutor banner"
      />
    </div>

    <div class="auth-form">
      <RouterLink to="/">
        <img
          class="auth-form-logo"
          src="../assets/images/logo-videomedi.png"
          alt="Videomedi"
        />
      </RouterLink>

      <div class="auth-form-container">
        <!-- <BaseAlert variant="info" class="mb-4">
          Enviamos um e-mail de confirmação para o endere&ccedil;o cadastrado.
          Confirme-o antes de agendar uma consulta.
        </BaseAlert> -->

        <PhoneVerificationForm @verified="onVerified" />
      </div>
    </div>
  </div>
</template>

<script>
import PhoneVerificationForm from "../components/PhoneVerificationForm.vue";

export default {
  name: "PhoneVerificationView",
  components: {
    PhoneVerificationForm
  },
  methods: {
    onVerified() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.auth-form-logo {
  display: block;
  height: 40px;
  width: auto;
}
</style>
